import { useEffect } from 'react';
import './styles.scss';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateHeader } from '../../slices/header-slice';

import contactHero from '../../assets/images/contact-feedback/contact-hero.png';
import success from '../../assets/images/contact-feedback/success-icon.png';

const ContactSubmitted = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(updateHeader('dark'));
    }, [dispatch]);

    // Script injection effect
    useEffect(() => {
        const inlineScript = document.createElement('script');
        inlineScript.innerHTML = `
            var $wc_load=function(a){return JSON.parse(JSON.stringify(a))}, 
                $wc_leads=$wc_leads||{
                    doc:{
                        url:$wc_load(document.URL), 
                        ref:$wc_load(document.referrer), 
                        search:$wc_load(location.search), 
                        hash:$wc_load(location.hash)
                    }
                };
        `;
        document.body.appendChild(inlineScript);

        const externalScript = document.createElement('script');
        externalScript.src = '//s.ksrndkehqnwntyxlhgto.com/146188.js';
        externalScript.async = true;
        document.body.appendChild(externalScript);

        return () => {
            document.body.removeChild(inlineScript);
            document.body.removeChild(externalScript);
        };
    }, []);

    return (
        <div className="contact-submitted-page">
            <div className="contact-submitted-content">
                <div className="success-icon"><img src={success} alt="success" /> Success</div>

                <h2>We’ve received your email</h2>
                <p>Thank you for your enquiry. A member of our team will be in touch with you on our next business day. In the meantime, learn more about who we are & our dedication to the Art by clicking the link below.</p>

                <img src={contactHero} alt="contact hero" />
                <button className="cta gold-fill" onClick={() => navigate('/our-story')}>Our Story</button>
            </div>
        </div>
    );
};

export default ContactSubmitted;
